import * as React from "react";
import PropTypes from 'prop-types';

const SvgYdtBopisStore = props => {
  if (props.id !== "_svgydtbopisstore") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 32 32" {...props}><path d="M16.835 24.29a1.474 1.474 0 11-.002 2.946 1.474 1.474 0 01.002-2.945zm6.982 0a1.473 1.473 0 11-.002 2.944 1.473 1.473 0 01.002-2.943zM21.47 4a4.364 4.364 0 014.364 4.364l-.001.014h.96c.482 0 .873.391.873.873V21.47c0 1.011-.81 1.836-1.821 1.854l-10.282-.003c-1.084.02-1.979-.656-1.998-1.74-.002-.09.003-.18.013-.27L15.05 9.052a.762.762 0 01.758-.672h1.299v-.015A4.364 4.364 0 0121.47 4zM10.857 18.442a.819.819 0 01.111 1.629l-.11.007h-5.04a.818.818 0 01-.111-1.628l.111-.008h5.04zm-.186-3.587a.818.818 0 01.111 1.628l-.11.008H6.634a.818.818 0 01-.111-1.629l.11-.007h4.037zm7.747-3.819h-1.637a4.364 4.364 0 008.721.164l.004-.164H23.87a2.728 2.728 0 01-5.431.301l-.018-.176-.004-.125zm-6.656.219a.818.818 0 01.111 1.628l-.11.008H8.816a.819.819 0 01-.111-1.629l.11-.007h2.946zm9.71-5.619a2.728 2.728 0 00-2.728 2.728l-.001.014h5.455v-.014a2.727 2.727 0 00-2.727-2.728z" /></svg>;
};

SvgYdtBopisStore.displayName = "_svgydtbopisstore";
SvgYdtBopisStore.propTypes = {
  id: PropTypes.string
};
SvgYdtBopisStore.defaultProps = {
  id: ''
};
export default SvgYdtBopisStore;